import React from "react";

export default function EyeIcon({ open = false, style = {}, ...props }: any) {
  return open ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', ...style }}
      {...props}
    >
      <path
        d="M1 12C3.5 7 8 4 12 4c4 0 8.5 3 11 8-2.5 5-7 8-11 8-4 0-8.5-3-11-8z"
        stroke="#3256a2"
        strokeWidth="2"
        fill="none"
        opacity="0.85"
      />
      <circle
        cx="12"
        cy="12"
        r="3.5"
        stroke="#3256a2"
        strokeWidth="2"
        fill="none"
        opacity="0.85"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', ...style }}
      {...props}
    >
      <path
        d="M1 12C3.5 7 8 4 12 4c4 0 8.5 3 11 8-2.5 5-7 8-11 8-4 0-8.5-3-11-8z"
        stroke="#3256a2"
        strokeWidth="2"
        fill="none"
        opacity="0.85"
      />
      <circle
        cx="12"
        cy="12"
        r="3.5"
        stroke="#3256a2"
        strokeWidth="2"
        fill="none"
        opacity="0.85"
      />
      <line
        x1="4"
        y1="20"
        x2="20"
        y2="4"
        stroke="#3256a2"
        strokeWidth="2"
        opacity="0.7"
      />
    </svg>
  );
}
